<template>
    <nav id="contextual-footer">
        <template
            v-for="item in contextualFooterNav"
            :key="item.label"
        >
            <h3>
                {{ item.label }}
            </h3>

            <BaseQuicklinkList
                :links="item.items.map(t => ({
                    ...t,
                    text: t.contextTitle ?? t.title,
                    uri: `/${t.uri}`
                }))"
            />
        </template>
    </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const t = useTranslation('context-nav');

type Props = {
    ancestors: Array<any>;
    title: string;
    uri: string;
}
const props = defineProps<Props>();


const getContextualLabel = (item: {__typename: string}) => {
    switch (item.__typename) {
    case 'condition_condition_Entry':
        return t('condition');
    case 'condition_stage_Entry':
        return t('stage');
    case 'condition_treatment_Entry':
        return t('treatment');
    default:
        return t('related');
    }
};


const setActive = (items: Array<any>) => items.map(item => ({
    ...item,
    active: props?.uri?.startsWith(item.uri)
}));


const contextualFooterNav = computed(() => {
    const ancestors = props?.ancestors ?? [];
    const isTopLevel = ancestors?.length === 0;

    const mainParentItem = !isTopLevel ?
        {
            ...ancestors?.[0],
            children: undefined,
            active: true
        } : {
            title: props?.title,
            __typename: 'condition_condition_Entry',
            uri: props?.uri,
        };

    return [
        // eslint-disable-next-line no-shadow
        ...ancestors.map(c => setActive(c?.children)).reverse(),
        [
            mainParentItem,
            {
                title: t('condition-all'),
                uri: 'all-conditions',
            }
        ]
    ].filter(items => items.length).map(items => ({
        label: getContextualLabel(items?.[0]),
        items
    }));
});
</script>
